import { AppThunk } from '../../../store/rootReducer';
import { CREATE_NOISE_WAVE } from '../../analytics/analytics.constants';
import { trackCreateWave } from '../../analytics/thunks/track-create-wave.thunk';
import { createModeSelector } from '../selectors/create.selectors';
import { InvalidWaveType, Wave } from '../types/wave.type';
import { CreateMode } from '../utils/create.utils';
import {
  appendTags,
  DEFAULT_WAVE_LENGTH,
  generateWaveId,
} from '../utils/wave.util';
import { addWave } from './add-wave.thunk';

export const createNoiseWave =
  (timestamp: number, leads: string[]): AppThunk =>
  async (dispatch, getState) => {
    const createMode = createModeSelector(getState());

    const addNewWave = (timestamp: number, type: InvalidWaveType) => {
      const wave: Wave = {
        id: generateWaveId(),
        onset: timestamp - DEFAULT_WAVE_LENGTH[type] / 2,
        offset: timestamp + DEFAULT_WAVE_LENGTH[type] / 2,
        tags: appendTags([type], leads, 'manual'),
        type,
        background: false,
      };

      dispatch(addWave(wave));
    };

    switch (createMode) {
      case CreateMode.noise:
        dispatch(trackCreateWave(CREATE_NOISE_WAVE, 'noise'));
        addNewWave(timestamp, 'noise');
        break;
      case CreateMode.calibration:
        dispatch(trackCreateWave(CREATE_NOISE_WAVE, 'calibration'));
        addNewWave(timestamp, 'calibration');
        break;
      case CreateMode.artifact:
        dispatch(trackCreateWave(CREATE_NOISE_WAVE, 'artifact'));
        addNewWave(timestamp, 'artifact');
        break;
      case CreateMode.no_signal:
        dispatch(trackCreateWave(CREATE_NOISE_WAVE, 'no_signal'));
        addNewWave(timestamp, 'no_signal');
        break;
      case CreateMode.p_level_noise:
        dispatch(trackCreateWave(CREATE_NOISE_WAVE, 'p_level_noise'));
        addNewWave(timestamp, 'p_level_noise');
        break;
      case CreateMode.qrs_level_noise:
        dispatch(trackCreateWave(CREATE_NOISE_WAVE, 'qrs_level_noise'));
        addNewWave(timestamp, 'qrs_level_noise');
        break;
      case CreateMode.pt_level_noise:
        dispatch(trackCreateWave(CREATE_NOISE_WAVE, 'pt_level_noise'));
        addNewWave(timestamp, 'pt_level_noise');
        break;
      case CreateMode.uncertain:
        dispatch(trackCreateWave(CREATE_NOISE_WAVE, 'uncertain'));
        addNewWave(timestamp, 'uncertain');
        break;
      case CreateMode.microvolted:
        dispatch(trackCreateWave(CREATE_NOISE_WAVE, 'microvolted'));
        addNewWave(timestamp, 'microvolted');
        break;
    }
  };
